// eslint-disable-next-line no-control-regex
export const emailRegEx = new RegExp('[^@ \t\r\n]+@[^@ \t\r\n]+.[^@ \t\r\n]+');
